import { Message } from './';
export class DialogMessage {
    constructor() {
        this.id = null;
        this.question = new Message();
    }
}
